import styled from "styled-components";

import { colors } from "shared/ui";

export const Container = styled.div`
    max-width: 720px;
    padding-bottom: 28px;
    display: flex;
    flex-direction: column;
    gap: 16px;
`;

export const Placeholder = styled.div`
    padding: 32px 8px;
    color: ${colors.textSecondary};
`;

// Нередактируемое значение поля: та же высота, что у TextInput, но без рамки.
export const Value = styled.div`
    display: flex;
    align-items: center;
    height: 44px;
    font-size: 15px;
    color: ${colors.textPrimary};
`;
